'use client';
import { setCookie, getCookie } from 'cookies-next';

import { diffDate } from './tools/diffDate';

export const hotelYouLike = (hotels, startDate, endDate, isClick) => {
  const data =
    getCookie('DataLayer') &&
    JSON.parse(getCookie('DataLayer')?.toString() || '');
  if (
    !isClick &&
    window.location.href === data?.hotel_url &&
    data?.hotel_you_like
  )
    return;

  const formattedStartDate = startDate ? startDate : '';
  const formattedEndDate = endDate ? endDate : '';
  const items: any[] = [];
  hotels &&
    hotels?.map((hotel, index) => {
      const region: string[] =
        (hotel?.region && hotel?.region.split(', ')) || [];
      items.push({
        item_id: hotel?.id || 0,
        item_name: hotel?.name || '',
        affiliation: 'Setur Web',
        coupon: '',
        currency: 'TRY',
        discount: (hotel?.price || 0) - (hotel?.discountedPrice || 0),
        index: index,
        item_brand: 'Setur',
        item_category: 'Otel',
        item_category2: 'Yurtiçi Otelleri',
        item_category3: 'Beğenebileceğiniz Diğer Oteller',
        item_category4: region[0] || '',
        item_category5: region[1] || '',
        cd_item_list_location: 'Detail Page',
        item_list_id: 'Beğenebileceğiniz Diğer Oteller',
        item_list_name: 'Detail Page - Beğenebileceğiniz Diğer Oteller',
        item_variant: '',
        cd_item_checkin_date: formattedStartDate,
        cd_item_checkout_date: formattedEndDate,
        cd_item_room_type: '',
        cd_item_list_filter: '',
        cd_item_sorting_opt: 'Popüler',
        cd_item_hotel_score: 0,
        cd_item_pet_friendly: 'No',
        cd_item_near_to_city_center: 'No',
        cd_item_is_seaside: 'No',
        cd_item_has_blue_flag: 'No',
        cd_item_has_aquapark: 'No',
        cd_item_otel_concept: hotel?.boardType || '',
        cd_item_city: '',
        cd_item_region: region[0] || '',
        cd_item_disabled_friendly: 'No',
        cd_item_is_conservative: 'No',
        cd_item_honeymoon: 'No',
        cm_item_discount_rate: parseFloat(hotel?.rate || 0) / 100,
        cd_item_days_till_vacation: startDate
          ? diffDate(new Date().toString(), startDate)
          : 0,
        cm_item_total_people_count: 2,
        cd_item_child_free: 'No',
        cd_item_has_fly: 'No',
        cm_item_total_reservation_day:
          startDate && endDate ? diffDate(startDate, endDate) : 0,
        cm_item_adult_number: 2,
        cm_item_child_number: 0,
        cd_item_in_stock: 'Yes',
        cd_item_first_price: hotel?.price || 0,
        price: hotel?.discountedPrice || 0,
        quantity: 1,
      });
    });
  if (items.length > 0) {
    if (isClick) {
      dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    } else {
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    }
    setCookie(
      'DataLayer',
      {
        ...data,
        hotel_item_list_location: items[0]?.cd_item_list_location,
        hotel_item_list_id: items[0]?.item_list_id,
        hotel_url: window.location.href,
        hotel_you_like: true,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  }
};

export const tourYouLike = (hotels, isClick) => {
  const data =
    getCookie('DataLayer') &&
    JSON.parse(getCookie('DataLayer')?.toString() || '');
  if (
    !isClick &&
    window.location.href === data?.tour_url &&
    data?.tour_you_like
  )
    return;
  const items: any[] = [];
  hotels &&
    hotels?.map((hotel, index) => {
      const isDomestic = true;
      items.push({
        item_id: hotel?.id || 0,
        item_name: hotel?.name || '',
        affiliation: 'Setur Web',
        coupon: '',
        currency: 'TRY',
        discount: 0,
        index: index,
        item_brand: 'Setur',
        item_category: 'Tur',
        item_category2: isDomestic ? 'Yurtiçi Turlar' : 'Yurtdışı Turlar',
        item_category3: 'Beğenebileceğiniz Diğer Turlar',
        item_category4: '',
        item_category5: '',
        cd_item_list_location: 'Detail Page',
        item_list_id: 'Beğenebileceğiniz Diğer Turlar',
        item_list_name: 'Detail Page - Beğenebileceğiniz Diğer Turlar',
        item_variant: '',
        cd_item_checkin_date: '',
        cd_item_checkout_date: '',
        cd_item_room_type: '',
        cd_item_list_filter: '',
        cd_item_sorting_opt: 'Popüler',
        cd_item_hotel_score: 0,
        cd_item_pet_friendly: 'No',
        cd_item_near_to_city_center: 'No',
        cd_item_is_seaside: 'No',
        cd_item_has_blue_flag: 'No',
        cd_item_has_aquapark: 'No',
        cd_item_otel_concept: '',
        cd_item_city: '',
        cd_item_region: '',
        cd_item_disabled_friendly: 'No',
        cd_item_is_conservative: 'No',
        cd_item_honeymoon: 'No',
        cm_item_discount_rate: 0,
        cd_item_days_till_vacation: 0,
        cm_item_total_people_count: 2,
        cd_item_child_free: 'No',
        cd_item_has_fly: 'No',
        cm_item_total_reservation_day: 0,
        cm_item_adult_number: 2,
        cm_item_child_number: 0,
        cd_item_in_stock: 'Yes',
        cd_item_first_price: 0,
        price: 0,
        quantity: 1,
      });
    });
  if (items.length > 0) {
    if (isClick) {
      dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    } else {
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    }
    setCookie(
      'DataLayer',
      {
        ...data,
        tourl_item_list_location: items[0]?.cd_item_list_location,
        tour_item_list_id: items[0]?.item_list_id,
        tour_url: window.location.href,
        tour_you_like: true,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  }
};
